import { FC, HTMLAttributes, ReactElement } from 'react';

import { useGameGridContext } from '../GameGridContext';

export interface GameGridContentConnectedProps extends HTMLAttributes<HTMLDivElement> { }

export const GameGridContentConnected: FC<GameGridContentConnectedProps> = ({ children, className, ...rest }): ReactElement => {
  const {
    refs: { contentRef },
  } = useGameGridContext();

  return (
    <div className={className} ref={contentRef} {...rest}>
      {children}
    </div>
  );
};
